import { LOCALE } from "@milize/common/constants";
import { createIntl } from "react-intl";
import EnLang from "./entries/en-US";
import JaLang from "./entries/ja-JP";

const AppLocale: Record<keyof typeof LOCALE, typeof EnLang | typeof JaLang> = {
  en: EnLang,
  ja: JaLang,
};

export const DEFAULT_LOCALE = "ja";

export const intl = createIntl({
  locale: DEFAULT_LOCALE,
  messages: AppLocale[DEFAULT_LOCALE].messages,
});

export default AppLocale;
